import { render, staticRenderFns } from "./SortCalendarDescendingIcon.vue?vue&type=template&id=71614a9b"
import script from "./SortCalendarDescendingIcon.vue?vue&type=script&lang=js"
export * from "./SortCalendarDescendingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports